export default "__VITE_ASSET__2DXoMMof__"